<template>
  <permission-gate
    moduleKey="recursos"
    :showNoEditAlert="true"
  >
    <template #default="{ canEdit }">
      <main-breadcrumb
        :items="items"
        showBackButton
      ></main-breadcrumb>
      <main-buttons-bar :align="'space-between'">
        <template #left>
          <custom-title>Edición de recurso</custom-title>
        </template>
      </main-buttons-bar>

      <detail-container>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <custom-input
            v-model="recurso.Descripcion"
            :label="'Descripción'"
            :spanColumn="7"
            :settings="{
              placeholder: 'Ingresar descripción',
              // inputClass:{'input-error': !validateResourceFields.Descripcion },
            }"
          />
          <custom-input
            v-model="recurso.CodigoRenglonEquivalente"
            :label="'Código renglón equivalente'"
            :spanColumn="7"
            :settings="{
              placeholder: 'Ingresar código',
              maxlength: 50,
              showWordLimit: true,
            }"
          />
          <el-col :span="1"></el-col>
          <el-col :span="3">
            <div class="custom-label">Activo</div>
            <el-switch
              v-model="recurso.Activo"
              active-text="Si"
              inactive-text="No"
              class="mb-2"
              sieze="large"
            />
          </el-col>
          <custom-data
            :label="'Fecha creación'"
            :spanColumn="3"
            :data="recurso.FechaCreacion ? getDate('dd/mm/yyyy', recurso.FechaCreacion) : ''"
          />
          <custom-data
            :label="'Creado por'"
            :spanColumn="2"
            :data="
              recurso.UsuarioCreacion && recurso.UsuarioCreacion.Usuario
                ? recurso.UsuarioCreacion.Usuario
                : '-'
            "
          />
        </el-row>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <el-col :span="4">
            <custom-select
              v-model="recurso.RecursoTipo"
              :label="'Tipo recurso'"
              :settings="{
                // inputClass:{'input-error': !validateResourceFields.RecursoTipo },
                options: recursoTipoList,
              }"
              @update:modelValue="handleRecursoTipoChange"
            />
          </el-col>
          <el-col :span="4">
            <custom-select
              v-model="recurso.Moneda"
              :label="'Moneda'"
              :settings="{
                placeholder: 'Seleccionar moneda',
                options: monedaList,
              }"
              @change="(val) => setCodigoMoneda(val)"
            />
          </el-col>
          <el-col :span="4">
            <custom-select
              v-model="recurso.CilindroTipo"
              :label="'Tipo cilindro'"
              :settings="{
                placeholder: 'Seleccionar tipo cilindro',
                options: cilindroTipoList,
                clearable: true,
              }"
              @update:modelValue="handleCilindroTipoChange"
              @click:clearable="handleCilindroTipoClear"
            />
          </el-col>
          <custom-input-number
            v-model="recurso.CostoHora"
            :label="'Costo (Hora)'"
            :spanColumn="6"
            :settings="{
              placeholder: `Costo (Hora)`,
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-data
            :label="'Fecha actualización'"
            :spanColumn="3"
            :data="
              recurso.FechaActualizacion ? getDate('dd/mm/yyyy', recurso.FechaActualizacion) : ''
            "
          />

          <custom-data
            :label="'Actualizado por'"
            :spanColumn="2"
            :data="
              recurso.UsuarioActualizacion && recurso.UsuarioActualizacion.Usuario
                ? recurso.UsuarioActualizacion.Usuario
                : '-'
            "
          />
        </el-row>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <custom-input-number
            v-model="recurso.CantidadColor"
            :label="labelCantidadColor"
            :spanColumn="4"
            :settings="{
              placeholder: `${unidadMedida ?? 'UM'} Color`,
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-input-number
            v-model="recurso.TiempoPreparacionColor"
            :label="labelTiempoPreparacionColor"
            :spanColumn="6"
            :settings="{
              placeholder: `Tiempo preparación color (${unidadTiempo})`,
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
        </el-row>
        <el-row
          :gutter="24"
          class="input-margin"
        >
          <custom-input-number
            v-model="recurso.TiempoPolimero"
            :label="labelTiempoPolimero"
            :spanColumn="6"
            :settings="{
              placeholder: labelTiempoPolimero,
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-input-number
            v-model="recurso.MermaPolimero"
            :label="labelMermaPolimero"
            :spanColumn="6"
            :settings="{
              placeholder: labelMermaPolimero,
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-input-number
            v-model="recurso.AnchoMaximo"
            label="Ancho máximo (mm)"
            :spanColumn="6"
            :settings="{
              placeholder: 'Ancho máximo de la máquina',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-input-number
            v-model="recurso.LargoMaximo"
            label="Largo máximo (mm)"
            :spanColumn="6"
            :settings="{
              placeholder: 'Largo máximo de la máquina',
              min: 0,
              precision: 2,
              step: 0.01,
              controls: false,
            }"
          />
          <custom-input-number
            v-if="esExtrusora"
            v-model="recurso.TornillosMaximos"
            label="Tornillos máximo"
            :spanColumn="4"
            :settings="{
              placeholder: 'Cantidad máx. de tornillos/capas',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
            }"
          />
          <custom-input-number
            v-if="esImpresora"
            v-model="recurso.CantidadCuerposImpresores"
            label="Cantidad de cuerpos impresores"
            :spanColumn="4"
            :settings="{
              placeholder: 'Cantidad máx. de cuerpos',
              min: 0,
              precision: 0,
              step: 1,
              controls: false,
            }"
          />
          <custom-fraction-mm-input
            v-model="recurso.LargoMaximoPlatina"
            :label="'Largo máximo platina'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Valor en mm o fracción de pulgada (ej: 1/8)',
            }"
          ></custom-fraction-mm-input>
          <custom-fraction-mm-input
            v-model="recurso.PasoPlatina"
            :label="'Paso platina'"
            :spanColumn="4"
            :settings="{
              placeholder: 'Valor en mm o fracción de pulgada (ej: 1/8)',
            }"
          ></custom-fraction-mm-input>
        </el-row>
        <resource-process
          :processes="recurso.ProcesoRecurso"
          @addProcess="addProcess"
          @deleteProcess="deleteProcess"
        />

        <el-row
          :gutter="24"
          class="input-margin"
        >
          <el-col :span="8">
            <div class="custom-label">Imagen</div>
            <div
              v-if="shownImageUrl"
              style="margin: 8px 0"
            >
              <img
                :key="shownImageUrl"
                :src="shownImageUrl"
                style="
                  max-width: 100%;
                  max-height: 160px;
                  border: 1px solid #ddd;
                  border-radius: 6px;
                "
              />
            </div>

            <el-upload
              :auto-upload="false"
              :limit="1"
              accept="image/png,image/jpeg,image/webp"
              :on-change="onFileChange"
              :on-remove="onFileRemove"
              :file-list="fileList"
              :before-upload="() => false"
            >
              <el-button
                type="primary"
                size="default"
                >Seleccionar imagen</el-button
              >
            </el-upload>

            <el-checkbox
              v-model="removeImage"
              :disabled="!!file"
            >
              Quitar imagen actual
            </el-checkbox>
            <div style="font-size: 12px; opacity: 0.7">
              Si adjuntás una nueva imagen, se reemplaza la anterior automáticamente.
            </div>
          </el-col>
        </el-row>
      </detail-container>
      <!-- Atributos Dinámicos -->
      <RecursoAtributosForm
        ref="atributosFormRef"
        v-model="recurso.AtributosAdicionales"
        :readonly="false"
        layout="grid"
        :columns="2"
      />

      <div
        v-if="canEdit"
        class="container"
      >
        <custom-confirm-buttons
          :disabled="false"
          :showLoading="true"
          :confirmText="'Guardar'"
          :cancelText="'Cancelar'"
          @on-cancel="onCancel"
          @on-confirm="onConfirm"
        />
      </div>
    </template>
  </permission-gate>
</template>

<script setup>
import {
  onBeforeMount,
  computed,
  ref,
} from 'vue';
import { useRecursoStore } from '@/stores/recurso_store.js';
import { storeToRefs } from 'pinia';
import {
  useRoute,
  useRouter,
} from 'vue-router';
import MainBreadcrumb from '@/shared/layout/main/main_breadcrum.vue';
import MainButtonsBar from '@/shared/layout/main/buttons_bar/main_buttons_bar.vue';
import DetailContainer from '@/shared/layout/detail/detail_container.vue';
import CustomData from '@/shared/components/custom_data.vue';
import CustomTitle from '@/shared/components/custom_title.vue';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomInputNumber from '@/shared/components/custom_input_number.vue';
import CustomFractionMmInput from '@/shared/components/custom_fraction_mm_input.vue';
import CustomConfirmButtons from '@/shared/components/custom_confirm_buttons.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import RecursoAtributosForm from '@/shared/components/atributos-dinamicos/RecursoAtributosForm.vue';
import getDate from '@/shared/components/utils.js';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import { useMonedaStore } from '@/stores/moneda/moneda_store';
import recursoTipoService from '@/services/recurso_tipo_service.js';
import {
  resolverLabelsMatrizImpresion,
  conUnidad,
} from '@/shared/utils/label_matriz_impresion.js';
import { useRecursoTipoStore } from '@/stores/recurso_tipo_store.js';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo.js';
import ResourceProcess from '../components/resource_process.vue';
import PermissionGate from '@/shared/components/permission_gate.vue';
import { esRecursoImpresora } from '@/shared/composables/useCuerpoImpresor.js';

const route = useRoute();
const router = useRouter();
const recursoStore = useRecursoStore();
const monedaStore = useMonedaStore();
const { recurso } = storeToRefs(recursoStore);
const {
  resetResource,
  findResourceByCodigoHTTP,
  updateResourceHTTP,
  addProcess,
  deleteProcess,
  setCodigoMoneda,
} = recursoStore;
const { monedaList } = storeToRefs(monedaStore);
const { firstMoneda } = monedaStore;
const recursoTipoList = ref([]);
const cilindroTipoStore = useCilindroTipoStore();
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);
const file = ref(null);
const fileList = ref([]);
const previewUrl = ref('');
const removeImage = ref(false);
const atributosFormRef = ref(null);

// local state
const items = [
  { label: 'Inicio', to: '/page/resource/list', replace: false },
  { label: 'Edición', to: null, replace: false },
];

const unidadMedida = computed(() => recurso.value.RecursoTipo?.UnidadMedida?.Descripcion || '');
const unidadTiempo = computed(() => recurso.value.RecursoTipo?.UnidadTiempo?.Descripcion || '');
const esExtrusora = computed(() => {
  const clave = recurso.value.RecursoTipo?.ClaveInterna;
  return clave === 'extrusora_blown_film' || clave === 'extrusora_cast';
});
const esImpresora = computed(() => esRecursoImpresora(recurso.value.RecursoTipo));

// const labelCostoHora = computed(() => `Costo ${unidadTiempo.value}`)
const labelCantidadColor = computed(() => `${unidadMedida.value ?? 'UM'} Color`);
// const labelMetrosPreparacion = computed(() => `${unidadMedida.value} Preparación`)
// const labelMetrosColor = computed(() => `${unidadMedida.value} Color`)
// const labelPromedioProduccion = computed(() => `Promedio producción (${unidadTiempo.value})`)
// const labelTiempoPreparacionFijo = computed(() => `Tiempo preparación fijo (${unidadTiempo.value})`)
const labelTiempoPreparacionColor = computed(
  () => `Tiempo preparación color (${unidadTiempo.value})`,
);
// COTI-502: Determinar label para polimero
const labelsMatriz = computed(() => resolverLabelsMatrizImpresion(recurso.value.RecursoTipo));
const labelTiempoPolimero = computed(() =>
  conUnidad(labelsMatriz.value.tiempo, unidadTiempo.value),
);
const labelMermaPolimero = computed(() =>
  conUnidad(labelsMatriz.value.merma, unidadMedida.value || 'UM'),
);
// const labelPromedioProduccionTroquelado = computed(() => `Promedio producción troquelado (${unidadTiempo.value})`)

function handleRecursoTipoChange(item) {
  recurso.value.CodigoRecursoTipo = item.Codigo;
  if (!esRecursoImpresora(item)) recurso.value.CantidadCuerposImpresores = null;
}

function handleCilindroTipoChange(item) {
  recurso.value.CodigoTipoCilindro = item?.Codigo ?? null;
}

function handleCilindroTipoClear() {
  recurso.value.CilindroTipo = null;
  recurso.value.CodigoTipoCilindro = null;
}

function toPublicUrl(rel = '') {
  const API_BASE = import.meta.env.VITE_URL_BASE_API || '';
  const PUBLIC_BASE = API_BASE.replace(/\/api\/?$/, '');
  if (!rel) return '';
  if (/^https?:\/\//i.test(rel)) return rel;
  if (rel.startsWith('/assets/')) return `${PUBLIC_BASE}${rel}`;
  return `${PUBLIC_BASE}/assets/${rel}`;
}
const dbImageUrl = computed(() =>
  recurso.value?.ImagenUrl ? toPublicUrl(recurso.value.ImagenUrl) : '',
);
const shownImageUrl = computed(() => previewUrl.value || dbImageUrl.value);

function onFileChange(fileEvt, fileListEvt) {
  file.value = fileEvt?.raw || null;
  fileList.value = fileListEvt;
  removeImage.value = false;
  previewUrl.value = file.value ? URL.createObjectURL(file.value) : '';
}

function onFileRemove() {
  file.value = null;
  fileList.value = [];
  previewUrl.value = '';
}
const onConfirm = async () => {
  try {
    useLoading().openLoading();
    await updateResourceHTTP({ file: file.value, removeImage: removeImage.value });
    useMessageSuccess().open('Los datos se han actualizado correctamente.');
    const id = route.params.id;
    if (id && +id > 0) {
      await findResourceByCodigoHTTP(id);
    }
  } catch (err) {
    const errorMessage =
      err.response?.data?.message || 'Ha ocurrido un error al intentar actualizar los datos.';
    useMessageError().open(errorMessage);
  } finally {
    useLoading().closeLoading();
  }
};

const onCancel = () => {
  resetResource();
  router.push('/page/resource/list');
};

const fetchRecursoTipoList = async () => {
  try {
    const res = await recursoTipoService.findAll({ page: 0 });
    if (res?.data) recursoTipoList.value = res.data;
  } catch (err) {
    console.error('Error fetching recurso tipo list:', err);
  }
};

onBeforeMount(async () => {
  firstMoneda();
  await fetchRecursoTipoList();
  const id = route.params.id;
  if (id && +id > 0) {
    await findResourceByCodigoHTTP(id);
  }
});
</script>

<style scoped>
.container {
  display: flex;
  justify-content: flex-end; /* Alinea todo el contenido al final del contenedor */
}
</style>
